import { render, staticRenderFns } from "./MoneyRange.vue?vue&type=template&id=b239e672&"
import script from "./MoneyRange.vue?vue&type=script&lang=js&"
export * from "./MoneyRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports